import { Guid } from '@fitscovery/common/types';

export class GetPartnerMembershipSubscriptionsByPartnerId {
    static readonly type = '[PartnerMembershipSubscription] GetPartnerMembershipSubscriptionsById';

    constructor(public partnerId: Guid) { }
}

export class GetPartnerActiveMembershipSubscriptionsByPartnerId {
    static readonly type = '[PartnerMembershipSubscription] GetPartnerActiveMembershipSubscriptionsById';

    constructor(public partnerId: Guid) { }
}